import {Component, Input} from "@angular/core";
import {StatusIndicatorState} from "./status-indicator-state";
import { ErrorMoreDialogComponent } from "./error-more-details-dialog.component"
import {DialogService} from "../bootstrap-modal/dialog.service";

@Component({
  selector: "status-indicator",
  templateUrl: "./status-indicator.template.pug",
  providers: [
    DialogService,
  ],
})
export class StatusIndicatorComponent {
  key: string;
  text: string;
  color: string;
  detail: any;
  details: [];
  states: StatusIndicatorState[] = [];
  errorDetail:string;
  isVisibleViewMoreButton:boolean = false
  @Input("states")
  set statesProp(states: StatusIndicatorState[]) {
    this.states = states;
    this.updateDisplay();
  }

  get statesProp(): StatusIndicatorState[] {
    return this.states;
  }

  @Input("errorDetail")
  set errorDetailProp(errorDetail: string){
    this.errorDetail = errorDetail;
    this.updateDisplay();
  }

  get errorDetailProp(): string {
    return this.errorDetail;
  }

  @Input("key")
  set keyProp(key: string) {
    this.key = key;
    this.updateDisplay();
  }

  get keyProp(): string {
    return this.key;
  }

  @Input("details")
  set detailsProp(details: []) {
    this.details = details;
    this.updateDisplay();
  }

  get detailsProp(): [] {
    return this.details;
  }

  @Input("detail")
  set detailProp(detail: any) {
    if (typeof detail === "object") {
      this.details = detail;
      this.detail = "";
    } else {
      this.detail = detail;
    }
    this.updateDisplay();

  }

  updateDisplay() {
    const key = this.key;
    const state = this.states.find(it => it.key === key);
    if (state) {
      this.text = state.text || "";
      this.color = state.color || "";
      if(state.key == 'upload-failed'){
        this.isVisibleViewMoreButton = true;
      }else{
        this.isVisibleViewMoreButton = false;
      }
    } else {
      this.text = "";
      this.color = "";
    }
    
  }
  public create(): void {

    ErrorMoreDialogComponent.showCreateDialog(this.dialogService,this.details);
  }
  constructor(public dialogService: DialogService) {}

}
